import Image from 'next/image';
import Link from 'next/link';
import Logo from 'public//img/Logo.png';

import ShadowImage from '~components/ui/ShadowImage';
import { NormalizedCinemasInComplex } from '~utils/normalizers/normalizeCinemaInComplex';

import style from './CinemasDetail.module.css';

interface CinemasDetailProps {
  data: Required<NormalizedCinemasInComplex>;
}

export const getGoogleMapsUrl = (name: string, address: string) =>
  `https://www.google.com/maps/dir/?api=1&destination=Citicinemas+${encodeURIComponent(
    name,
  )}+${encodeURIComponent(address)}`;

function CinemasDetail({ data }: CinemasDetailProps) {
  return (
    <div className={style.root}>
      <div className="block h-full w-full">
        {data?.image?.url ? (
          <ShadowImage
            data={data?.image}
            className="aspect-video h-[inherit] w-full"
            version="url"
          />
        ) : (
          <div className={style.imagePlaceholder}>
            <Image alt="Logo de Citicinemas" src={Logo} width={100} height={100} />
          </div>
        )}
      </div>
      <div className="space-y-4">
        <h2 className={style.cinemaName}>{data?.name}</h2>
        <dl className={style.info}>
          <div>
            <dt>Dirección:</dt>
            <dd>{data?.address}</dd>
          </div>
          <div>
            <dt>Teléfonos:</dt>
            <dd>{data?.phoneNumbers}</dd>
          </div>
        </dl>
        <div className={style.services}>
          {data.Services?.map?.((service) => (
            <div key={service?.id} data-tooltip={service?.name}>
              <Image src={service?.icon?.url} alt={service?.name} width={24} height={24} />
            </div>
          ))}
        </div>
        <div>
          <Link href={`/cartelera-${data?.slug}`} className="btn btn-primary mr-4">
            Ver Cartelera
          </Link>
          <Link
            className="btn btn-secondary"
            href={getGoogleMapsUrl(data?.name, data?.address)}
            target="_blank"
            rel="nofollow noreferrer"
          >
            Cómo llegar
          </Link>
        </div>
      </div>
    </div>
  );
}

export default CinemasDetail;
